import React from 'react';
import './Required.scss';

export const Required: React.FunctionComponent = (props) => {
	return (
		<>&nbsp;*</>
	);
};
